/**
 * Sets a cookie with optional expiration (only runs on client).
 * @param {string} name - The cookie name.
 * @param {string} value - The cookie value.
 * @param {Date} [exp] - Optional expiration date.
 */
export function setCookie(name, value, exp) {
    if (typeof document === 'undefined' || typeof location === 'undefined') return;

    const Days = 180;
    if (!exp) {
        exp = new Date();
        exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
    }

    const encodedValue = encodeURIComponent(value);
    const expiresStr = `expires=${exp.toUTCString()}`;
    const isLocalhost = location.origin === 'http://localhost:3015';
    const base = `${name}=${encodedValue};path=/;${expiresStr}`;

    document.cookie = isLocalhost ? base : `${base};SameSite=None;Secure`;
}

/**
 * Removes a cookie by setting its expiration to a past date (client only).
 * @param {string} name - The cookie name to remove.
 */
export function removeCookie(name) {
    if (typeof document === 'undefined' || typeof location === 'undefined') return;

    const expired = 'Thu, 01 Jan 1970 00:00:01 GMT';
    const isLocalhost = location.origin === 'http://localhost:3015';
    const base = `${name}=;path=/;expires=${expired}`;

    document.cookie = isLocalhost ? base : `${base};SameSite=None;Secure`;
}

/**
 * Gets the value of a cookie (client only).
 * @param {string} name - The cookie name.
 * @returns {string|null} The cookie value or null if not found.
 */
export function getCookie(name) {
    if (typeof document === 'undefined') return null;

    const regex = new RegExp(`(?:^| )${name}=([^;]*)(?:;|$)`);
    const match = document.cookie.match(regex);
    return match ? decodeURIComponent(match[1]) : null;
}
